// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select-container{display:flex;align-items:center;justify-content:center;height:300px}.loader-container{height:300px}.select-element{width:300px;display:flex;flex-direction:column;justify-content:center;align-items:center;user-select:none;cursor:pointer}.select-icon{margin-bottom:15px;color:var(--primary);font-size:57px}", ""]);
// Exports
module.exports = exports;
